import React from 'react';
import styled, { keyframes } from 'styled-components';
import { color } from 'styled-system';

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translate3d(0px, 45px, 0px);
  }

  100% {
    opacity: 0.9;
    transform: translate3d(0px, 0px, 0px);
  }
`;

const fadeOut = keyframes`
  0% {
    opacity: 0.9;
    transform: translate3d(0px, 0px, 0px);
  }

  100% {
    opacity: 0;
    transform: translate3d(0px, 45px, 0px);
  }
`;

const Wrapper = styled.div`
  position: absolute;
  bottom: 50px;
  left: 0;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 14px;
  line-height: 100%;
  text-align: center;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  opacity: ${({ out }) => (out ? 0 : 0.9)};
  z-index: 999;

  animation: ${({ out }) => (out ? fadeOut : fadeIn)} 0.3s linear 1;

  ${color}
`;

function PopUp({ visible, out, children }) {
  return (
    <Wrapper bg="grey_600" color="white" visible={visible} out={out}>
      {children}
    </Wrapper>
  );
}

export default PopUp;
